import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { LocalOffice } from '../../../../core/store/admin/local-office/local-office.interface';

@Component({
  selector: 'app-local-office-filter',
  templateUrl: './local-office-filter.component.html',
  styleUrls: ['./local-office-filter.component.scss']
})
export class LocalOfficeFilterComponent implements OnChanges {

  selectedLocalOfficeId?: string;
  @Input() localOffices: LocalOffice[];
  @Input() loading: boolean;
  @Input() busy: boolean;
  @Output() editLocalOffice = new EventEmitter<LocalOffice>();
  @Output() clearSelection = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.localOffices) {
      this.selectedLocalOfficeId = undefined;
    }
  }

  edit() {
    const localOffice = this.localOffices.find(localOffice => localOffice.id === this.selectedLocalOfficeId);
    this.editLocalOffice.emit(localOffice);
  }
}
